import React from 'react';
import PropTypes from "prop-types";
import { Tracks } from "react-compound-slider";
import Track from "./Track";
import { endOfToday, isAfter, isBefore, startOfToday } from "date-fns";
import { clampIntervals } from "../../../Common/Availability/Availability";
import { getTimelineOffset } from "../TimelineLogic";
import { intervalFromState } from "../../../Helpers/IntervalHelper";

const BlockedIntervalTracks = (props) => {

    const getTooltipFor = (className) => {
        if (!props.showTooltips) {
            return null;
        }

        switch (className) {
            case 'closed':
                return "Closed";
            case 'booked':
                return "Booked";
            default:
                return "Unavailable";
        }
    }

    const timelineInterval = intervalFromState(props.timelineInterval);
    const blockedIntervals = clampIntervals(props.blockedIntervals, timelineInterval);

    if (!blockedIntervals || !blockedIntervals.length) {
        return null;
    }

    return (
        <Tracks left={false} right={false}>
            {({ getTrackProps }) => (<>
                {blockedIntervals.map((blockedInterval, index) => {
                    let interval = intervalFromState({...blockedInterval});

                    if (isBefore(interval.start, timelineInterval.start)) {
                        interval.start = timelineInterval.start;
                    }

                    if (isAfter(interval.end, timelineInterval.end)) {
                        interval.end = timelineInterval.end;
                    }

                    return (
                        <Track
                            key={`blocked-track-${index}`}
                            sourceOffset={getTimelineOffset(timelineInterval, interval.start)}
                            targetOffset={getTimelineOffset(timelineInterval, interval.end)}
                            getTrackProps={getTrackProps}
                            className={(interval.status ? `timeslot-${interval.status}` : '')}
                            tooltip={getTooltipFor(interval.status)}
                            disabled
                        />
                    );
                })}
            </>)}
        </Tracks>
    )
};

BlockedIntervalTracks.propTypes = {
    timelineInterval: PropTypes.object,
    blockedIntervals: PropTypes.arrayOf(PropTypes.object),
    showTooltips: PropTypes.bool,
};

BlockedIntervalTracks.defaultProps = {
    timelineInterval: [startOfToday(), endOfToday()],
    blockedIntervals: [],
    showTooltips: true
};

export default BlockedIntervalTracks;
